// TSS vite/04 §"Endpoint paths".
// KPIs/informe del cliente (public-kpis.md + public-reports.md). No hay un
// endpoint KPI aparte — la superficie es public/stats con ?view=kpi|report|full.

export const statsPaths = {
    base: () => 'public/stats',
};
